import type React from "react";
import { useEffect, useRef } from "react";
import Seo from "../components/Seo";

const Schedule: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // This page is reached via full page navigation (not SPA routing)
    // so the script always loads fresh against an already-painted DOM.
    const script = document.createElement("script");
    script.src = "https://brandedweb.mindbodyonline.com/embed/widget.js";
    script.async = true;

    if (containerRef.current) {
      containerRef.current.appendChild(script);
    }

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div
      className="min-h-full"
      style={{ backgroundColor: "var(--color-complementary)" }}
    >
      <Seo
        title="Class Schedule"
        description="View the latest indoor cycling class schedule at Cycle Collective Saskatoon and book your ride. Classes for all levels, 7 days a week."
        path="/schedule"
      />
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1
            className="text-4xl font-bold mb-8"
            style={{ color: "var(--color-text)" }}
          >
            SCHEDULE
          </h1>
        </div>
        <div ref={containerRef} className="max-w-4xl mx-auto">
          {/* Mindbody Schedules Widget */}
          <div
            className="mindbody-widget"
            data-widget-type="Schedules"
            data-widget-id="21320999d15"
          />
        </div>
      </div>
    </div>
  );
};

export default Schedule;
